const colors = {
  primary: {
    '50': '#f9eae7',
    '10': 'rgba(252, 238, 228, 0.79)',
    '55': '#FDF0E7',
    '100': '#facebc',
    '200': '#f8ae91',
    '300': '#f59065',
    '400': '#f47943',
    '500': '#f26422',
    '600': '#e75e1e',
    '700': '#da571a',
    '800': '#cc5017',
    '900': '#b24411',
  },
  // Green in case of bimaboss
  secondary: {
    40: '#F2F7FA',
    '50': '#e4f1fa',
    '100': '#bcdcf3',
    '200': '#94c7ec',
    '300': '#6eb1e3',
    '400': '#54a1df',
    '500': '#3e92da',
    '600': '#3784cd',
    '700': '#2e73ba',
    '800': '#2863a8',
    '900': '#1c4689',
  },
  secondary2: {
    '50': '#eaedfa',
    '100': '#c1c9f0',
    '200': '#98a6e6',
    '300': '#6f82dd',
    '400': '#465ed3',
    '500': '#2c45b9',
    '600': '#223690',
    '700': '#192667',
    '800': '#0f173e',
    '900': '#050815',
  },

  // Blue in case of bimaboss
  tertiary: {
    50: '#dbebf7',
    100: '#c9e1f3',
    200: '#b7d7ef',
    300: '#93c3e8',
    400: '#6fafe0',
    500: '#4b9cd8',
    600: '#448cc2',
    700: '#3c7cad',
    800: '#2d5d82',
    900: '#264e6c',
  }, // sky blue bimaboss
  focus: '#7FAC07',
  warning: '#D0342C',
  appGrey: {
    50: '#FAFAFA',
    100: '#E8E8E8',
    200: '#E0E0E0',
    300: '#B3B3B3',
    400: '#DEDEDE',
    500: '#999999',
    600: '#8A8B8B',
  },
  appDarkGrey: '#E8E8E8',
} as const

export type Colors = typeof colors
export default colors
